import { useEffect, useRef } from 'react'
import { GtmAgent } from './GtmAgent'

/**
 * 送出頁面瀏覽事件，同一次掛載只會送出一次
 * （避免 SWR 在切換瀏覽器分頁後重新取資料時又送一次）。
 *
 * 「只送一次」的旗標必須用 useRef，不能用 useState，理由：
 * 1. genPageViewData 由呼叫端直接傳入 inline 函式（例如 useGtmArticlePageView），
 *    每次重繪都會是新的參考，所以這個 effect 會在「每一次重繪之後」都執行。
 * 2. useState 的更新要等下一次重繪才反映。只要在旗標生效前連續重繪了兩次以上
 *    （例如伺服器端算不出、必須等瀏覽器接手後才修正的值，會在畫面呈現前多繪一次），
 *    那幾次重繪各自排隊的 effect 都會讀到尚未更新的 false，事件就會重複送出。
 * 3. useRef 的寫入是同步生效的，先執行的 effect 標記完，後面排隊的 effect 立刻讀得到，
 *    才能真正保證只送一次。
 */
export const useGtmPageView = (genPageViewData) => {
  const isSentRef = useRef(false)
  useEffect(() => {
    if (isSentRef.current || !genPageViewData) {
      return
    }
    try {
      const data = genPageViewData()
      if (data !== null) {
        isSentRef.current = true
        GtmAgent.directSendToGTM(data)
      }
    } catch (err) {}
  }, [genPageViewData])
}
